/**
 * TenantLogin.tsx — ADR-0075: przekierowanie na CENTRALNE logowanie (public scope).
 *
 * W modelu "wspólne konto" logowanie ZAWSZE idzie przez jeden centralny ekran z wyborem
 * firmy (picker) — nie ma osobnego logowania per subdomena. Ta strona (wejście na
 * `<slug>.app.<base>/login`, wygaśnięcie sesji, stary bookmark) przekierowuje na
 * `app.<base>/login`, żeby przy KAŻDYM logowaniu pojawił się wybór tenanta.
 *
 * Historyczny formularz per-tenant + 2FA (F7b T7b.2) żyje w git — zastąpiony central-login.
 */

import { useEffect } from 'react';

import { Spinner } from '@/components/Spinner';
import { buildCentralLoginUrl } from '@/lib/tenant-url';

export function TenantLogin() {
  useEffect(() => {
    // Full nav (nie react-router) — zmiana scope (tenant → public) wymaga re-resolve
    // hosta przy cold starcie SPA. replace(): nie zostawia per-tenant loginu w historii.
    window.location.replace(buildCentralLoginUrl());
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-bg-secondary">
      <Spinner />
    </main>
  );
}
